export default __webpack_public_path__ + "static/media/window.23271c1a.png";